import { Component, Input, OnInit } from "@angular/core";


@Component({
    selector: 'app-activites-guest-price-summary',
    templateUrl: './activites-guest-price-summary.component.html',
    styleUrls: ['./activites-guest-price-summary.component.scss', './../activities-lite.component.scss'],
    standalone: false
})
  
  export class ActivitesGuestPriceSummaryComponent implements OnInit{

    @Input() priceDetail: GuestPriceShort;
    @Input() currency: string;

    paymentSplitKeyLabels = [
        { key: 'SubTotal', label: 'SubTotal'},
        { key: 'ServiceCharge', label: 'serviceCharges'},
        { key: 'Tax', label: 'Tax'},
        { key: 'TaxOnServiceChargeAmount', label: 'taxOnserviceCharge'},
        { key: 'VAT', label: 'VAT'},
        { key: 'VATOnServiceChargeAmount', label: 'VATOnserviceCharge'}
      ]

    ngOnInit(): void {
        
      return;
    }
  }


  export interface GuestPriceShort{
    Items: any[];
    SubTotal: number;
    Total: number;
    ServiceCharge: number;
    Tax: number;
    VAT: number;
    VATOnServiceChargeAmount: number;
  }
